import { SagaIterator } from "redux-saga"
import { call, takeEvery } from "redux-saga/effects"
import { LocalStorageKeys } from "~/interfaces/entities/LocalStorageKeys"
import { actions } from "~/redux/process"
import { getApplication } from "~/redux/saga/application"
import { ApplicationState } from "~/redux/state/application"

export function* watchSaveAttributionData() {
  yield takeEvery(
    actions.saveAttributionData.type,
    saveAttributionDataToLocalStorage
  )
}

function* getLocalStorageKeys(): SagaIterator<
  Pick<LocalStorageKeys, "localStorageAttributionTrackingKey">
> {
  const application: ApplicationState = yield call(getApplication)

  const localStorageAttributionTrackingKey =
    application.localStorageAttributionTrackingKey

  return {
    localStorageAttributionTrackingKey,
  }
}

function* saveAttributionDataToLocalStorage() {
  try {
    const localStorageKeys: LocalStorageKeys = yield call(getLocalStorageKeys)
    const startingUrl = window.location.href
    const url = new URL(startingUrl)
    const searchParams = new URLSearchParams(url.search)

    const attributionDataObject: Record<string, string> = {
      url: `${url.origin}${url.pathname}`,
    }

    searchParams.forEach((value, key) => {
      attributionDataObject[key] = value
    })

    localStorage.setItem(
      localStorageKeys.localStorageAttributionTrackingKey,
      JSON.stringify(attributionDataObject)
    )
  } catch (error) {
    console.error("Error saving attribution data to local storage:", error)
  }
}
